<template>
  <v-app class="custom-app">
  <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop"><v-icon>mdi-apple-keyboard-control</v-icon></v-btn>
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col text-center">
          <div class="custom-header-top">
            <router-link to="/" class="custom-top-logo">
              <img class="fluid-img" src="./static/logo-eematico-toys-jucarii.png" alt="eematico toys logo">
            </router-link>
            <div class="custom-right-navigation">
                <router-link to="/">RO</router-link>
                <router-link to="/en">EN</router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
     <router-view></router-view>
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col">
          <div class="custom-border"></div>
          <h2 class="custom-subtitle">CONTACT</h2>
          <div class="custom-contact-container">
            <v-row>
              <v-col sm="4" cols="12" class="text-center">
                <a href="tel:+40743565588" target="_blank" class="custom-contact-link">
                  <img src=./static/icons/phone.svg alt="eematico toys phone"/>
                  <p>0743.565.588</p>
                </a>                
              </v-col>
              <v-col sm="4" cols="12" class="text-center">
                <a href="mailto:toys@eematico.org" target="_blank" class="custom-contact-link">
                  <img src=./static/icons/mail.svg alt="eematico toys mail"/>
                  <p>toys@eematico.org</p>
                </a>                
              </v-col>
              <v-col sm="4" cols="12" class="text-center">
                <a href="https://www.google.com/maps/place/Splaiul+Unirii+160,+Bucure%C8%99ti,+Romania/@44.412551,26.117611,16z/data=!4m2!3m1!1s0x40b1fefc68528709:0x71638261c266915c?hl=it-IT&gl=US" target="_blank" class="custom-contact-link">
                  <img src=./static/icons/location.svg alt="eematico toys location"/>
                  <p>{{ $t('address') }}</p>
                </a>                
              </v-col> 
            </v-row>                           
          </div>
        </v-col>    
      </v-row>
    </v-container>    
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col">
          <div class="custom-border"></div>
          <h2 class="custom-subtitle">{{ $t('URMĂREŞTE-NEPE') }}</h2>
          <div class="custom-container-social">
            <a href="https://www.facebook.com/eematicoToys/" target="_blank" rel="noopener" class="custom-links-social">
              <img src="./static/icons/facebook.svg" alt="eematico toys facebook" class="custom-img-icons-social">
            </a>
            <a href="https://twitter.com/eematico" target="_blank" rel="noopener" class="custom-links-social">
              <img src="./static/icons/twitter.svg" alt="eematico toys facebook" class="custom-img-icons-social">
            </a> 
            <a href="https://ro.pinterest.com/eematico/" target="_blank" rel="noopener" class="custom-links-social">
              <img src="./static/icons/pinterest.svg" alt="eematico toys facebook" class="custom-img-icons-social">
            </a> 
            <a href="https://www.instagram.com/eematico/" target="_blank" rel="noopener" class="custom-links-social">
              <img src="./static/icons/instagram.svg" alt="eematico toys facebook" class="custom-img-icons-social">
            </a> 
            <a href="https://www.youtube.com/channel/UCdMe5b9sRwUJZTzG4_uspVg" target="_blank" rel="noopener"  class="custom-links-social">
              <img src="./static/icons/youtube.svg" alt="eematico toys facebook" class="custom-img-icons-social">
            </a>              
          </div>         
        </v-col>    
      </v-row>
    </v-container>  
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col">
          <div class="custom-border"></div>
          <h2 class="custom-subtitle">{{ $t('newsletter') }}</h2>
          <div class="custom-newsletter-contaier">
            <v-form ref="formNewsletter" v-model="validNewsletter" :lazy-validation="lazy">
              <v-container class="custom-padding-container">              
                <v-row>
                  <v-col sm="6" cols="12">
                    <v-text-field v-model="emailNewsletter" :rules="emailRulesNewsletter" label="E-mail" required></v-text-field>
                    <v-text-field v-model="emailSurName" label="surName" class="custom-surname"></v-text-field>
                  </v-col>
                  <v-col sm="6" cols="12" class="text-center">
                    <v-btn class="custom-button-form" @click.prevent="validateNewsletter" :height="'auto'">{{ $t('trimite') }}</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-alert type="success" v-if="showMsgNewsletter">
                      {{ $t('nlSuccess') }}
                    </v-alert>
                    <v-alert type="error" v-if="errorSubmit">
                      {{ $t('nlError') }}
                    </v-alert>     
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </div>
        </v-col>         
      </v-row>
    </v-container>
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col text-center">
             
        </v-col>
      </v-row>
    </v-container>    
    <v-container class="custom-padding-container">
      <v-row>
        <v-col cols="12" class="custom-padding-col">
          <div class="custom-footer">
            <div class="custom-footer-link">
              <v-container>
                <v-row justify="center">
                  <v-col md="10" col="12">

                    <v-row>
                      <v-col md="4" cols="6">
                        <router-link to="/politica-de-confidentialitate">{{ $t('politica') }}</router-link>
                        <router-link to="/politica-de-cookies">{{ $t('cookies') }}</router-link>
                      </v-col>
                      <v-col md="4" cols="6">
                        <router-link to="/termeni-si-conditii">{{ $t('terms') }}</router-link>
                        <a href="https://www.anpc.ro/" targe="_blank" rel="noopener">ANPC</a>
                      </v-col>                    
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app> 
</template>
<script>
  export default{
    data(){
      return{
        checkbox: false,
        lazy: false,
        validNewsletter:true,
        emailNewsletter:'',
        emailRulesNewsletter:[ v => !!v || 'E-mail is required',v => /.+@.+\..+/.test(v) || 'E-mail must be valid',],
        emailSurName:'',
        fab: false,
        showMsgNewsletter:false,
        errorSubmit:false,
          }
    },
    methods: {
          validateNewsletter(){
            if (this.$refs.formNewsletter.validate()){
              if(this.emailSurName===''){
                var _this  = this;
                this.errorSubmit=false;
                this.$axios.post('http://toys-new.eematico.org/newsletter.php', {
                  email: this.emailNewsletter,
                  eematicoToysNewsletter: true
                })
                .then(function (response) {
                  if(response.data===1){
                    _this.showMsgNewsletter = true;
                    _this.emailNewsletter='';
                  }else{
                    _this.errorSubmit = true;
                    _this.emailNewsletter='';
                  }
                  
                })
              }else{
                this.errorSubmit = true;
                this.emailNewsletter='';
              }
            }
          },
          onScroll (e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset ||   e.target.scrollTop || 0
            this.fab = top > 20
            },
          toTop () {
            this.$vuetify.goTo(0)
          }
    }
  }

</script>
<style lang="scss">
$spacer:1rem;
$light-black:#626262;
$custom-yellow:#ffdd17;
#app.custom-app{
  background:#ffffff;
}
#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #626262;
  .container{
    max-width:1164px;
  }
  .custom-surname{
    display:none;
  }
  .v-input--selection-controls.v-input{
    margin:0;
    padding:0;
  }
  .fluid-img{
    max-width:100%;
    width:100;
  }
  .custom-padding-container{
    padding-top:0;
    padding-bottom:0;
  }
  .custom-padding-col{
    padding-top:0;
    padding-bottom:0;
  }
  .custom-header-top{
    margin:($spacer*1.25) 0;
    .custom-top-logo{ 
      display:block;
    }
  }
  .custom-right-navigation{
    text-align:right;
    padding-right:10px;
    a{
      margin-left:1rem;
      text-decoration:none;
      color:$light-black;      
    }
  }
  .custom-header-banner{
    position:relative;
    .custom-banner-text{
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: #fff;
      text-align: center;
      max-width:590px;
      width:100%;
      h1{
        font-size: ($spacer * 3.4375);
        font-weight: 600;
        border-bottom:2px solid #fff;
        display:inline-block;
        padding-bottom:($spacer * 0.25);
      }
      p{
        line-height: ($spacer * 1.2);
        font-size: ($spacer);
        text-transform: lowercase;
        margin-top: ($spacer * 1.875);
        span{
          color: $custom-yellow;
          font-weight: 700;
        }
      }
      h2{
        color: $custom-yellow;
        font-weight: 700;
        font-size: ($spacer * 1.625);
        margin: ($spacer * 2.5) 0;
      }   
      a{
        background: transparent url(./static/eematico-toys-arrow.png);
        height: 60px;
        width: 60px;
        display: block;
        margin: 30px auto 0;
      }   
    }
  }
  .custom-item-top{
    width: 20%;
    padding: 25px;
    text-align: center;
  }
  .custom-items-container{
    display:flex;
    h2{
      font-weight: 700;
      font-size: ($spacer * 1.25);
      line-height: ($spacer * 1.625);
      padding: 0 8%;
      margin-bottom: $spacer;
      min-height:($spacer * 4.875);
    }
  }
  .custom-item-top:nth-child(1) h2{
    color: #f05788;
  }
  .custom-item-top:nth-child(2) h2{
    color: #f26829;
  }
  .custom-item-top:nth-child(3) h2{
    color: #41b649;
  }
  .custom-item-top:nth-child(4) h2{
    color: #2bb673;
  }
  .custom-item-top:nth-child(5) h2{
    color: #939598;
  }
  .custom-border{
    border-top:2px solid #939598;
    margin-top:($spacer * 2.5);
  }
  .custom-subtitle{
    color:#f26829;
    font-weight: 700;
    font-style: normal;
    font-size: ($spacer * 1.625);
    line-height: 1.3;
    padding:($spacer * 2.5) 0; 
    text-align:center;
  }          
  .products-info{
    margin-bottom:($spacer * 4);
    h2{
      font-size: ($spacer * 1.875);
      font-weight: 800;
      margin-top: ($spacer * 0.5);
      padding-bottom: ($spacer * 1.25);
      display: inline-block;
      margin-bottom: ($spacer * 1.25);
      line-height:1.875rem;
    }
    .title1{
      color: #2bb673;
      border-bottom:1px solid #2bb673;
    }
    .title2{
      color: #f05788;
      border-bottom:1px solid  #f05788;
    }    
    p{
      line-height: ($spacer * 1.25);
      margin-bottom: $spacer;
    }
    .custom-product-btn{
      color: #fff;
      background: #f26829;
      border-radius: 10px;
      padding: $spacer ($spacer * 4);
      border: 1px solid #fff;
      margin-top:($spacer * 3);
    }
    span{
      color:#145819;
      font-size:$spacer;
      display:block;
    }
  }
  .custom-about-us p{
    margin-bottom: ($spacer * 1.875);
  }
  .custom-button-form{
    margin-top:($spacer);
    background:#f26829;
    font-weight: 400;
    padding: $spacer ($spacer * 4);
    color:#ffffff;
    span{
      color:#ffffff;
    }
  }
  .custom-para-programe{
    font-size: 16px;
    text-align: center;
    line-height:($spacer * 2);
    margin-top:($spacer);
    margin-bottom: ($spacer * 3.75);
    width: 65%;
    margin: 0 auto;
  }
  .custom-button-programe{
    text-align: center;
    margin-top: 50px;
    display: inline-block;
    padding: 20px 95px;
    background: #f26829;
    color:#ffffff;
  }
  .custom-contact-container{
    img{
      max-height:60px;
      height:100%;
    }
  }
  .custom-container-social{
    text-align:center;
    .custom-links-social{
      display:inline-block;
      max-width:46px;
      width:100%;
      margin:0 ($spacer * 1.5);
      .custom-img-icons-social{
      }
    }
  }
  .custom-contact-link{
    text-decoration:none;
    p{
      font-size: ($spacer * 1.25);
      font-weight: 300;
      margin: ($spacer * 1.875) 0;
      line-height: ($spacer * 1.5625);
      color:$light-black;
    }
  }
  .custom-footer{
        background: url(./static/eematico-toys-jucarii-footer-img.jpg);
        background-repeat: no-repeat;
        height: 100%;
        display: block;
    .custom-footer-link{
        margin-top: ($spacer * 3.125);
      a{
        display:block;
        color:#fff;
        text-decoration:none;
      }
      a:hover{
        text-decoration:underline;
      }
    }
  }
}
@media (max-width:995px){
  #app{
    .custom-items-container{
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      h2{
        min-height:auto;
      }
    }
    .custom-item-top{
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
      text-align: center;
    }
    .custom-item-top.last-item{
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;     
      text-align:center;
    }
    .custom-item-top.last-item p{
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%; 
      margin:0 auto;
    }
    .custom-banner-text{
      p{
        display:none;
      }
    }
  }
}
@media (max-width: 600px){
  #app{
    .custom-order{
      order:1;
    }
    .custom-order2{
      order:2;
    }

    .custom-item-top{
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
      text-align: center;
    }    
    .custom-header-banner{
      .custom-banner-text{
        h1{
          font-size: ($spacer * 2);
        }
        h2{
          font-size: ($spacer * 1.25);
          margin: ($spacer * 1.25) 0;
        }
      }
    }    
    .custom-container-social{
      .custom-links-social {
        margin: 0 0.75rem;
      } 
    }

  }
}
@media (max-width:450px){
  #app{
    .custom-header-banner{
      .custom-banner-text{
        h1{
          font-size: ($spacer * 1.5);
        }
        h2{
          display:none;
        }
      }
    }      
  }
}
@media (max-width:380px){
  #app{
    .custom-container-social{
      .custom-links-social {
        max-width: 43px;
        margin: 0 0.5rem;
      } 
    }
  }
}
</style>
